{
  "success": {
    "default": "Operazione riuscita",
    "save": "Salvato",
    "remove": "Eliminazione effettuata",
    "detach": {
      "user": "Il seguente utente è stato scollegato correttamente dalla rete { sectorName } | I seguenti utenti sono stati scollegati correttamente dalla rete { sectorName }",
      "device": "Il seguente apparato è stato scollegato correttamente dalla rete { sectorName } | I seguenti apparati sono stati scollegati correttamente dalla rete { sectorName }",
      "application": "La seguente applicazione è stata scollegata correttamente dalla rete { sectorName } | Le seguenti applicazioni sono state scollegate correttamente dalla rete { sectorName }",
      "userGroup": "Il seguente gruppo utente è stato scollegato correttamente dalla rete { sectorName } | I seguenti gruppi utenti sono stati scollegati correttamente dalla rete { sectorName }",
      "dtwins": "Il seguente apparato è stato scollegato correttamente dalla rete { sectorName } | I seguenti apparati sono stati scollegati correttamente dalla rete { sectorName }"
    },
    "attach": {
      "user": "Il seguente utente è stato collegato correttamente alla rete { sectorName } | I seguenti utenti sono stati collegati correttamente alla rete { sectorName }",
      "device": "Il seguente apparato è stato collegato correttamente alla rete { sectorName } | I seguenti apparati sono stati collegati correttamente alla rete { sectorName }",
      "application": "La seguente applicazione è stata collegata correttamente alla rete { sectorName } | Le seguenti applicazioni sono state collegate correttamente alla rete { sectorName }",
      "userGroup": "Il seguente gruppo utente è stato collegato correttamente alla rete { sectorName } | I seguenti gruppi utenti sono stati collegati correttamente alla rete { sectorName }",
      "dtwins": "Il seguente apparato è stato collegato correttamente alla rete { sectorName } | I seguenti apparati sono stati collegati correttamente alla rete { sectorName }"
    },
    "certificate": {
      "generation": "Il certificato utente è stato generato correttamente."
    }
  },
  "cancellation": {
    "cancel": "Modifiche annullate"
  },
  "inProgress": {
    "save": "Salvataggio in corso"
  },
  "error": {
    "default": "Si è verificato un errore",
    "unexpectedApiError": "Si è verificato un errore imprevisto",
    "save": "Salvataggio non riuscito",
    "remove": "L’eliminazione non è andata a buon fine",
    "upload": "L’importazione non è andata a buon fine, si prega di ricominciare",
    "detach": {
      "user": "Lo scollegamento del seguente utente dalla rete { sectorName } non è andato a buon fine | Gli scollegamenti dei seguenti utenti dalla rete { sectorName } non sono andati a buon fine",
      "device": "Lo scollegamento del seguente apparato dalla rete { sectorName } non è andato a buon fine | Gli scollegamenti dei seguenti apparati dalla rete { sectorName } non sono andati a buon fine",
      "application": "Lo scollegamento della seguente applicazione dalla rete { sectorName } non è andato a buon fine | Gli scollegamenti delle seguenti applicazioni dalla rete { sectorName } non sono andati a buon fine",
      "userGroup": "Lo scollegamento del seguente gruppo utenti dalla rete { sectorName } non è andato a buon fine | Gli scollegamenti dei seguenti gruppi utenti dalla rete { sectorName } non sono andati a buon fine",
      "dtwins": "Lo scollegamento del seguente apparato dalla rete { sectorName } non è andato a buon fine | Gli scollegamenti dei seguenti apparati dalla rete { sectorName } non sono andati a buon fine"
    },
    "attach": {
      "user": "Il collegamento del seguente utente alla rete { sectorName } non è andato a buon fine | I collegamenti dei seguenti utenti alla rete { sectorName } non sono andati a buon fine",
      "device": "Il collegamento del seguente apparato alla rete { sectorName } non è andato a buon fine | I collegamenti dei seguenti apparati alla rete { sectorName } non sono andati a buon fine",
      "application": "Il collegamento della seguente applicazione alla rete { sectorName } non è andato a buon fine | I collegamenti delle seguenti applicazioni alla rete { sectorName } non sono andati a buon fine",
      "userGroup": "Il collegamento del seguente gruppo utenti alla rete { sectorName } non è andato a buon fine | I collegamenti dei seguenti gruppi utenti alla rete { sectorName } non sono andati a buon fine",
      "dtwins": "Il collegamento del seguente apparato alla rete { sectorName } non è andato a buon fine | I collegamenti dei seguenti apparati alla rete { sectorName } non sono andati a buon fine"
    },
    "campaign": {
      "firmware": "Impossibile programmare l’aggiornamento del firmware alla data desiderata"
    },
    "startDate": "La campagna è già ricominciata, non è possibile modificare le date di inizio e fine.",
    "keystore": {
      "aliasAlreadyUsed": {
        "title": "Alias già utilizzato",
        "message": "Usa un altro alias del certificato e riprova."
      }
    },
    "certificate": {
      "parsing": "Errore del certificato",
      "notValid": "Il certificato dell’API non è valido"
    }
  }
}
